// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__ATUtf","approved":"Status_approved__1I1v8","rejected":"Status_rejected__3E4X1","expired":"Status_expired__1YJmY","label":"Status_label__33QjZ"};